// extracted by mini-css-extract-plugin
export var layoutContainer = "_af-0";
export var layoutContainerNoRounding = "_af-6";
export var layoutContainerOpen = "_af-5";
export var layoutContainerResizing = "_af-1";
export var mainContent = "_af-2";
export var resizeDivider = "_af-3";
export var slidePanel = "_af-4";